// Sanitizador mínimo para el HTML enriquecido de "Valor" en Secuencias (ver RichTextEditor
// en CrudPage.jsx). Corre en el navegador antes de cada render público, así que aunque un
// admin guarde HTML raro, nunca llega sin filtrar a la pantalla del participante del test.
const ALLOWED_TAGS = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'BR', 'DIV', 'P', 'SPAN']);
const ALLOWED_STYLE_PROPS = new Set(['color', 'font-weight', 'font-style', 'text-align', 'text-decoration']);

function sanitizeStyle(styleText) {
  if (!styleText) return '';
  return styleText
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((decl) => {
      const idx = decl.indexOf(':');
      if (idx === -1) return null;
      const prop = decl.slice(0, idx).trim().toLowerCase();
      const value = decl.slice(idx + 1).trim();
      if (!ALLOWED_STYLE_PROPS.has(prop)) return null;
      if (/url\(|expression\(|javascript:/i.test(value)) return null;
      return `${prop}: ${value}`;
    })
    .filter(Boolean)
    .join('; ');
}

function sanitizeNode(node) {
  [...node.childNodes].forEach((child) => {
    if (child.nodeType === Node.ELEMENT_NODE) {
      if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE') {
        child.remove();
        return;
      }
      sanitizeNode(child);
      if (!ALLOWED_TAGS.has(child.tagName)) {
        while (child.firstChild) node.insertBefore(child.firstChild, child);
        node.removeChild(child);
      } else {
        const style = child.getAttribute('style');
        [...child.attributes].forEach((attr) => child.removeAttribute(attr.name));
        const cleanStyle = sanitizeStyle(style);
        if (cleanStyle) child.setAttribute('style', cleanStyle);
      }
    } else if (child.nodeType !== Node.TEXT_NODE) {
      child.remove();
    }
  });
}

export function sanitizeHtml(html) {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const root = doc.body.firstChild;
  sanitizeNode(root);
  return root.innerHTML;
}
